export enum InvoiceType {
  NET30 = 1,
  COD = 2,
  MANAGED = 3,
  UNKNOWN = 4,
}
